import { render, staticRenderFns } from "./AscDetailsList.vue?vue&type=template&id=780612b6&"
import script from "./AscDetailsList.vue?vue&type=script&lang=js&"
export * from "./AscDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports